import { render, staticRenderFns } from "./HotelStatistics.vue?vue&type=template&id=19755548"
import script from "./HotelStatistics.vue?vue&type=script&lang=js"
export * from "./HotelStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports